import {useDispatch} from 'react-redux';

// Component
import DealsDiscoveryModal from './DealsDiscoveryModal';
import Modal, {useModal} from '@stencil/hotels-modal-component';

//utils
import {detailsPagePushGaThunk} from '@stencil/hotels-ga/src';
import {DetailsGAClickEventActions} from '@stencil/hotels-config/src/config/ga-config';
import {appConfig} from '@stencil/hotels-config';
import {omnitureThunk, omnitureConfig} from '@stencil/omniture-analytics/src';
import {
  detailsClick,
  DetailsPageComponents,
} from '@stencil/omniture-analytics/src/constants/details';

//styles
import * as S from './styles/DealsDiscoveryWidget.styles';

const {rupeeString} = appConfig;

export default function DealsDiscoveryWidget({
  priceInfo = {},
  activeBankCode,
  bankPromoCount,
  bankDealsData,
  firstBankDealData,
  offersPersuasions = {},
  onPromoChange = code => {},
  onModalOpen = () => {},
}) {
  const {isModalOpen, closeModal, openModal} = useModal();

  const dispatch = useDispatch();

  const onPromoCodeSelection = code => {
    onPromoChange(code);
    closeModal();
  };

  // useEffect(() => {
  //   dispatch(
  //     detailsPagePushGaThunk({
  //       eventAction: DetailsGAClickEventActions.bankdeal.bank_offer_displayed,
  //       eventLabel: `size=${bankPromoCount}`,
  //     }),
  //   );
  // }, []);

  if (!firstBankDealData || !Object.keys(firstBankDealData)?.length) return null;

  const {coupons = [], couponDesc = '', couponAmount} = firstBankDealData || {};

  return (
    <>
      <S.DealsDiscoveryCard
        onClick={() => {
          onModalOpen();

          openModal();
          dispatch(
            omnitureThunk(omnitureConfig.pages.DetailsUnif, omnitureConfig.events.ctaClick, {
              cta: {
                name: `${DetailsPageComponents.DealsDiscoveryWidget}_${detailsClick.bankdeal.hotel_offersheet_opened}`,
                type: omnitureConfig.ctaType.Card,
                componentName: DetailsPageComponents.DealsDiscoveryWidget,
                destination: '',
              },
            }),
          );
        }}
      >
        {!!coupons?.[0]?.promoIconLink && (
          <S.Bank_Box>
            <S.Bank_Type_Img src={coupons?.[0]?.promoIconLink} />
          </S.Bank_Box>
        )}

        <S.DealsDiscoveryBaseColumnWrap>
          {coupons?.[0]?.code == activeBankCode ? (
            <>
              <S.Code_Applied_Header>{coupons?.[0]?.code} Code applied</S.Code_Applied_Header>
              <p>
                You saved {rupeeString}
                {couponAmount}
              </p>
            </>
          ) : (
            <>
              <S.Code_Applied_Header>Use {coupons?.[0]?.code} Code</S.Code_Applied_Header>
              <S.Code_Applied_SubHead
                dangerouslySetInnerHTML={{
                  __html: `Get ${rupeeString} ${couponAmount} off. ${couponDesc}`,
                }}
              />
            </>
          )}
        </S.DealsDiscoveryBaseColumnWrap>
        {bankPromoCount > 1 ? (
          <S.Know_More_Link
            onClick={e => {
              e.stopPropagation();
              onModalOpen();

              openModal();
              dispatch(
                omnitureThunk(omnitureConfig.pages.DetailsUnif, omnitureConfig.events.ctaClick, {
                  cta: {
                    name: `${DetailsPageComponents.DealsDiscoveryWidget}_${detailsClick.bankdeal.knowMoreClicked}`,
                    type: omnitureConfig.ctaType.Card,
                    componentName: DetailsPageComponents.DealsDiscoveryWidget,
                    destination: '',
                  },
                }),
              );
            }}
          >
            + {bankPromoCount - 1} more {bankPromoCount - 1 > 1 ? 'offers' : 'offer'}
          </S.Know_More_Link>
        ) : null}
        <Modal
          isOpen={isModalOpen}
          closeModal={closeModal}
          modalStyles={{
            width: '45rem',
          }}
          CloseButton={() => null}
        >
          <DealsDiscoveryModal
            closeModal={closeModal}
            activeBankCode={activeBankCode}
            offersPersuasions={offersPersuasions}
            priceInfo={priceInfo}
            bankDealsData={bankDealsData}
            onPromoCodeSelection={onPromoCodeSelection}
            bankPromoCount={bankPromoCount}
          />
        </Modal>
      </S.DealsDiscoveryCard>
    </>
  );
}
